import { render, staticRenderFns } from "./bpmeterdata_value.vue?vue&type=template&id=24b09418&"
import script from "./bpmeterdata_value.vue?vue&type=script&lang=js&"
export * from "./bpmeterdata_value.vue?vue&type=script&lang=js&"
import style0 from "./bpmeterdata_value.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports